import React, { useState } from 'react';
import { View } from "../../Components/Themed";
import DesktopAdminLayout from '../layouts/DesktopAdminLayout';
import MobileAdminLayout from '../layouts/MobileAdminLayout';

type AdminPortalProps = {
    insets: { top: number; bottom: number; left: number; right: number };
    onClose?: () => void;
    initialContestId?: string; // Optional contest ID to deep link to
    initialLeagueId?: string; // Optional league ID to deep link to
};

const AdminPortal = ({ insets, onClose, initialContestId, initialLeagueId }: AdminPortalProps) => {
    const [size, setSize] = useState({ width: 0, height: 0 });
    const isDesktop = size.width > 768;

    return (
        <View
            style={{ flex: 1 }}
            onLayout={(ev) => {
                const { height, width } = ev.nativeEvent.layout;
                setSize({ height, width });
            }}
        >
            {isDesktop ? (
                <DesktopAdminLayout
                    insets={insets}
                    onClose={onClose}
                    initialContestId={initialContestId}
                    initialLeagueId={initialLeagueId}
                />
            ) : (
                <MobileAdminLayout
                    insets={insets}
                    onClose={onClose}
                    initialContestId={initialContestId}
                    initialLeagueId={initialLeagueId}
                />
            )}
        </View>
    );
};

export default AdminPortal;
